module.exports = __webpack_public_path__ + "static/media/AHK.91aee2e6.png";